import React from "react";

const FBannerTitleButton = ({ imageUrl, title, titleButton }) => {
  return (
    <>
      <div className="border-0 grid place-items-center">
        <div className="border-0 grid grid-cols-12 xss:w-[450px] place-items-center">
          <div className="border-0 col-span-5 p-3">
            <img
              src={imageUrl}
              className="w-full xxs:w-[150px] h-auto flex-1"
            />
          </div>
          <div className="border-0 w-full  col-span-7 grid grid-rows-1 text-center sm:py-7 ">
            <div className="border-0 row-span-1 font-regular text-[4vw] smm:text-[20px]">
              {title}
            </div>
            <div className="border-0 row-span-1 font-regular text-[4vw] smm:text-[20px] px-3">
              {titleButton}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FBannerTitleButton;
